export default {
  brandColor1: '#114D97',
  complimentaryColor1: '#fff',
  brandColor2: '#114D97',
  complimentaryColor2: '#fff',
};
